import store from '@/store';
const useScheduler = () => {
    return {
        getSchedule: store.dispatch.schedule.getSchedule
    };
};
export default useScheduler;
